var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.705,
    height: 27.462,
    viewBox: "0 0 16.705 27.462",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.774,1.461,5.058.989A2.389,2.389,0,0,1,8.065,2.66L9.09,5.444a3.536,3.536,0,0,1-.613,3.526l-2.26,2.469A12.13,12.13,0,0,0,7.51,15.8a11.579,11.579,0,0,0,2.71,3.563l2.715-1.044a2.273,2.273,0,0,1,2.78,1.127l1.471,2.485a3.56,3.56,0,0,1-.308,4L15.9,27.065a3.287,3.287,0,0,1-3.642,1.068Q7.716,26.5,3.9,18.449T1.21,4.762A4.312,4.312,0,0,1,3.774,1.461Z",
    transform: "translate(-0.955 -0.859)",
    fill: "#c19444"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.8ddf86b41648b7d1179e40bf3ffeb4f0.svg";
export { ForwardRef as ReactComponent };